export default __webpack_public_path__ + "static/media/academy-logo.41594212.png";